/**
 * @generated SignedSource<<e7141ff378a7e37b33ff337ae7a1b479>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextElementDisplay_TextElementV2Fragment$data = {
  readonly text: string;
  readonly title: string;
  readonly " $fragmentType": "TextElementDisplay_TextElementV2Fragment";
};
export type TextElementDisplay_TextElementV2Fragment$key = {
  readonly " $data"?: TextElementDisplay_TextElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextElementDisplay_TextElementV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextElementDisplay_TextElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "TextLearnElement",
  "abstractKey": null
};

(node as any).hash = "c170d9eb74df1133422891368968f469";

export default node;
